import React, { useCallback, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Tabs,
  Divider,
  Card,
  Row,
  Col,
  Radio,
  InputNumber,
} from "antd";
import { Typography } from "antd";
import { AiFillCheckCircle, AiFillCloseSquare } from "react-icons/ai";
import ProductUtil from "../../components/ProductUtil";
import voucherApi from "../../api/voucherApi";
import { useSelector, useDispatch } from "react-redux";
import { currencyFormat } from "../../utils";
import addressApi from "../../api/addressApi";
import { MdOutlineAttachMoney } from "react-icons/md";
import Swal from "sweetalert2";
import orderApi from "../../api/orderApi";
import STATUS from "../../consts/status";
import TextArea from "antd/lib/input/TextArea";
import ghtkApi from "../../api/ghtkApi";

const OrderAdd = (props) => {
  const dollar = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z"
        fill="#fff"
      ></path>
      <path
        d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z"
        fill="#fff"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  let navigate = useNavigate();
  const goToPreviousPath = () => {
    navigate(-1);
  };
  const { Title } = Typography;

  const dispatch = useDispatch();

  const { TabPane } = Tabs;
  const confirm = Modal.confirm;
  const { Option } = Select;
  const [form] = Form.useForm();

  const [lstAddressStore, setLstAddressStore] = useState([]);

  const [lstVoucher, setLstVoucher] = useState([]);
  const [valueForm, setValueForm] = useState({
    status: "pending",
    paymentMethod: null,
    paymentStatus: null,
    shippingMethod: null,
    shippingStatus: null,
    customerName: null,
    email: null,
    phoneNumber: null,
  });
  const [totalMoneyProducts, setTotalMoneyProducts] = useState(0);
  const [totalMoney, setTotalMoney] = useState(0);
  const [totalShipping, setTotalShipping] = useState(0);

  const [voucherValue, setVoucherValue] = useState(0);

  const back = () => {
    confirm({
      title: "Mọi chỉnh sửa sẽ bị mất ! Tiếp tục quay lại?",
      onOk() {
        goToPreviousPath();
      },
      onCancel() {},
    });
  };

  const { productSelects } = useSelector((x) => x.product);

  const [province, setProvince] = useState([]);
  const [district, setDistrict] = useState([]);
  const [village, setVillage] = useState([]);

  const [province_ghtk, setProvince_Ghtk] = useState([]);
  const [district_ghtk, setDistrict_Ghtk] = useState([]);
  const [village_ghtk, setVillage_Ghtk] = useState([]);

  const [provinceSelect, setProvinceSelect] = useState(null);
  const [districtSelect, setDistrictSelect] = useState(null);
  const [wardSelect, setWardSelect] = useState(null);

  useEffect(() => {
    sumTotal();
  }, [productSelects, voucherValue, totalShipping]);

  useEffect(() => {
    getVouchers();
    getAddressStore();
    getShippingAddress("", "province");
    getShippingAddress_Ghtk("", "province");
  }, []);

  const getVouchers = () => {
    const params = {
      status: true,
      page: 1,
      limit: 100000,
    };
    voucherApi.getVouchers(params).then((res) => {
      if (res?.results) {
        setLstVoucher(res?.results);
      }
    });
  };

  const getAddressStore = () => {
    const params = { page: 1, limit: 1000 };
    addressApi.getShippingAddress(params).then((res) => {
      if (res?.results) {
        setLstAddressStore(res?.results);
      }
    });
  };

  const getShippingAddress = (code, type) => {
    const params = {
      parent_code: code,
    };
    addressApi.getAddress(params).then((res) => {
      if (res) {
        const data = res;
        if (type === "province") {
          setProvince(data);
          setDistrict([]);
          setVillage([]);
        } else if (type === "district") {
          form.setFieldsValue({
            district: null,
            districtName: null,
            villageName: null,
            village: null,
          });
          setDistrict(data);
          setVillage([]);
        } else if (type === "village") {
          form.setFieldsValue({
            village: null,
            villageName: null,
          });
          setVillage(data);
        }
      }
    });
  };

  const onChangeSelectProvince = (value, name) => {
    getShippingAddress(value, "district");
    form.setFieldsValue({
      provinceName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const onChangeSelectDistrict = (value, name) => {
    getShippingAddress(value, "village");
    form.setFieldsValue({
      districtName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const onChangeSelectVillage = (value, name) => {
    form.setFieldsValue({
      villageName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const getShippingAddress_Ghtk = (code, type) => {
    const params = {
      parent_id: code,
    };
    ghtkApi.getShipping(params).then((res) => {
      if (res.success) {
        const data = res.data;
        const lstAdd = data.map((item) => {
          return { code: item.id.toString(), name: item.name };
        });
        if (type === "province") {
          setProvince_Ghtk(lstAdd);
          setDistrict_Ghtk([]);
          setVillage_Ghtk([]);
        } else if (type === "district") {
          form.setFieldsValue({
            district: null,
            districtName: null,
            villageName: null,
            village: null,
          });
          setDistrict_Ghtk(lstAdd);
          setVillage_Ghtk([]);
        } else if (type === "village") {
          form.setFieldsValue({
            village: null,
            villageName: null,
          });
          setVillage_Ghtk(lstAdd);
        }
      }
    });
  };

  const onChangeSelectProvince_Ghtk = (value, name) => {
    getShippingAddress_Ghtk(value, "district");
    form.setFieldsValue({
      provinceName: name?.children,
    });
    // console.log(`selected ${value}`, name?.children);
    setProvinceSelect(name?.children);
  };

  const onChangeSelectDistrict_Ghtk = (value, name) => {
    getShippingAddress_Ghtk(value, "village");
    form.setFieldsValue({
      districtName: name?.children,
    });
    // console.log(`selected ${value}`, name?.children);
    setDistrictSelect(name?.children);
  };

  const onChangeSelectVillage_Ghtk = (value, name) => {
    form.setFieldsValue({
      villageName: name?.children,
    });
    // console.log(`selected ${value}`, name?.children);
    setWardSelect(name?.children);
  };

  const sumTotal = () => {
    if (productSelects.length > 0) {
      const sumProducts = productSelects.reduce(
        (accumulator, a) => accumulator + a.totalPrice,
        0
      );
      setTotalMoneyProducts(sumProducts);
      if (voucherValue > 0) {
        const sum = sumProducts - voucherValue;
        const shippingFee = totalShipping ? totalShipping : 0;
        const priceSum = sum + shippingFee;
        setTotalMoney(priceSum);
      } else {
        const shippingFee = totalShipping ? totalShipping : 0;
        const price = sumProducts + shippingFee;
        setTotalMoney(price);
      }
    }
  };

  const onSelectVoucher = (value, option) => {
    setVoucherValue(option.dataValue);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    if (productSelects.length > 0) {
      createOrder(values);
    } else {
      Swal.fire({
        title: "Thất bại!",
        text: "Vui lòng chọn sản phẩm!",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  const createOrder = (data) => {
    const productSelected = productSelects.map((item) => {
      return {
        productId: item.id,
        variantId: item.idTypeSelect,
        quantity: item.quantity,
      };
    });
    const payload = {
      status: data.status,
      paymentMethod: data.paymentMethod,
      paymentStatus: data.paymentStatus,
      shippingMethod: data.shippingMethod,
      shippingStatus: data.shippingStatus ? "delivered" : "delivered",
      customerName: data.customerName,
      email: data.email,
      phoneNumber: data.phoneNumber,
      address: {
        type: data.type,
        details: data.details,
        province: {
          name: data.provinceName == null ? "" : data.provinceName,
          id: data.province == null ? "" : data.province,
        },
        district: {
          name: data.districtName == null ? "" : data.districtName,
          id: data.district == null ? "" : data.district,
        },
        village: {
          name: data.villageName == null ? "" : data.villageName,
          id: data.village == null ? "" : data.village,
        },
      },
      transportFee: totalShipping ? totalShipping : 0,
      vouchers: [data.vouchers],
      products: productSelected,
      note: data.note,
    };

    orderApi.createOrder(payload).then(
      (res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Tạo thất bại",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };
  const [isShippingGhtk, setIsShippingGhtk] = useState(false);

  const changeShippingMethod = (value) => {
    if (value === STATUS.SHIPPING_GHTK) {
      setIsShippingGhtk(true);
    } else {
      setIsShippingGhtk(false);
    }
    form.setFieldsValue({
      provinceName: null,
      villageName: null,
      districtName: null,
      province: null,
      village: null,
      district: null,
    });

    setTotalShipping(0)
  };
  const [storeSelect, setStoreSelect] = useState(null);

  useEffect(() => {
    getFeeGhtk();
  }, [storeSelect, provinceSelect, districtSelect, wardSelect]);

  const getFeeGhtk = () => {
    const check = provinceSelect && districtSelect && wardSelect && storeSelect;
    if (check) {
      const pickAddress = storeSelect;

      const params = {
        pick_province: pickAddress.province.name,
        pick_district: pickAddress.district.name,
        pick_ward: pickAddress.village.name,
        province: provinceSelect,
        district: districtSelect,
        ward: wardSelect,
        deliver_option: "none",
        weight: 0,
      };
      ghtkApi.getFeeGhtk(params).then((res) => {
        if (res.success) {
          if (res.fee.delivery) {
            setTotalShipping(res.fee.fee);
          } else {
            Swal.fire({
              title: "Thất bại!",
              text: "GTHK chưa hỗ trợ giao hàng đến khu vực này!",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        }
      });
    }
  };

  const onSelectStore = (value, option) => {
    console.log(value, option);
    setStoreSelect(option.dataValue);
  };
  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24} md={24} className="mb-24">
          <Card
            className="header-solid h-full"
            bordered={false}
            title={<h6 className="font-semibold m-0">Thêm đơn hàng mới</h6>}
            extra={
              <>
                <Space>
                  <Button
                    type="primary"
                    icon={<AiFillCheckCircle />}
                    onClick={form.submit}
                  >
                    &nbsp;Đăng đơn hàng
                  </Button>
                  <Button
                    type="danger"
                    icon={<AiFillCloseSquare />}
                    onClick={() => {
                      back();
                    }}
                  >
                    &nbsp;Hủy
                  </Button>
                </Space>
              </>
            }
            bodyStyle={{ paddingTop: "0" }}
          >
            <Divider />
            <Form
              initialValues={valueForm}
              form={form}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 14,
              }}
              layout="horizontal"
              size="small"
            >
              {/* <label>Đơn hàng</label> */}
              <Title level={5}>Đơn hàng :</Title>
              <Form.Item
                label="Thạng thái đơn hàng"
                name="status"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn",
                  },
                ]}
              >
                <Select
                  disabled
                  status="warning"
                  showArrow
                  size="large"
                  optionFilterProp="children"
                  defaultValue="pending"
                >
                  <Option value={STATUS.ORDER_PENDING}>Chưa xác nhận</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Phương thức thanh toán"
                name="paymentMethod"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  <Option value="cod">Cod</Option>
                  <Option value="banking">Banking</Option>
                  <Option value="momo">Momo</Option>
                  <Option value="vnpay">Vnpay</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Thạng thái Thanh Toán"
                name="paymentStatus"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  <Option value={STATUS.PAYMENT_PAID}>Đã thanh toán</Option>
                  <Option value={STATUS.PAYMENT_NOT_PAID}>
                    Chưa thanh toán
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Phương thức vận chuyển "
                name="shippingMethod"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  onChange={changeShippingMethod}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  <Option value={STATUS.SHIPPING_VNFARM}>Tự vận chuyển</Option>
                  <Option value={STATUS.SHIPPING_GHTK}>
                    Giao hàng tiết kiệm
                  </Option>
                </Select>
              </Form.Item>
              {/* <Form.Item
                label="Thạng thái vận chuyển "
                name="shippingStatus"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  <Option value={STATUS.SHIPPING_PENDING}>Chờ xác nhận</Option>
                  <Option value={STATUS.SHIPPING_READY}>Chưa lấy hàng</Option>
                  <Option value={STATUS.SHIPPING_PICKUP}>Đã lấy hàng</Option>
                  <Option value={STATUS.SHIPPING_SHIPPING}>
                    Đang vận chuyển
                  </Option>
                  <Option value={STATUS.SHIPPING_DELIVERED}>
                    Đã giao hàng
                  </Option>
                </Select>
              </Form.Item> */}
              <Divider />
              <Title level={5}>Khách hàng :</Title>
              <Form.Item
                label="Họ và tên"
                name="customerName"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập",
                  },
                ]}
              >
                <Input placeholder="Nhập họ tên..." />
              </Form.Item>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "Email không đúng định dạng!",
                  },
                ]}
              >
                <Input placeholder="Nhập địa chỉ email..." />
              </Form.Item>
              <Form.Item
                label="Số điện thoại"
                name="phoneNumber"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập số điện thoại!",
                  },
                  {
                    pattern: new RegExp(/^[0-9]+$/),
                    message: "Số điện thoại không đúng định dạng!",
                  },
                ]}
              >
                <Input placeholder="Nhập số điện thoại..." />
              </Form.Item>
              <Divider />
              <Title level={5}>Địa chỉ giao hàng :</Title>
              <Form.Item
                label="Loại"
                name="type"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn!",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio value="home">Nhà riêng</Radio>
                  <Radio value="company">Công ty</Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                label="Đia chỉ"
                name="details"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập địa chỉ!",
                  },
                ]}
              >
                <Input placeholder="Nhập địa chỉ..." />
              </Form.Item>

              {isShippingGhtk ? (
                <>
                  <Form.Item
                    label="Tỉnh/Thành Phố"
                    name="province"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn tỉnh!!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      optionFilterProp="children"
                      onChange={onChangeSelectProvince_Ghtk}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {province_ghtk == null ||
                      province_ghtk === "undefined" ||
                      province_ghtk === []
                        ? []
                        : province_ghtk.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Quận/Huyện"
                    name="district"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn quận/huyện!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      onChange={onChangeSelectDistrict_Ghtk}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {district_ghtk == null ||
                      district_ghtk === "undefined" ||
                      district_ghtk === []
                        ? []
                        : district_ghtk.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Phường/Xã"
                    name="village"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn phường/xã!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      onChange={onChangeSelectVillage_Ghtk}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {village_ghtk == null ||
                      village_ghtk === "undefined" ||
                      village_ghtk === []
                        ? []
                        : village_ghtk.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                </>
              ) : (
                <>
                  <Form.Item
                    label="Tỉnh/Thành Phố"
                    name="province"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn tỉnh!!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      optionFilterProp="children"
                      onChange={onChangeSelectProvince}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {province == null ||
                      province === "undefined" ||
                      province === []
                        ? []
                        : province.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Quận/Huyện"
                    name="district"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn quận/huyện!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      onChange={onChangeSelectDistrict}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {district == null ||
                      district === "undefined" ||
                      district === []
                        ? []
                        : district.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Phường/Xã"
                    name="village"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn phường/xã!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      onChange={onChangeSelectVillage}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn..."
                    >
                      {village == null ||
                      village === "undefined" ||
                      village === []
                        ? []
                        : village.map((item, key) => (
                            <Option key={key} value={item.code}>
                              {item.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                </>
              )}

              <Form.Item hidden={true} label="provinceName" name="provinceName">
                <Input />
              </Form.Item>
              <Form.Item hidden={true} label="districtName" name="districtName">
                <Input />
              </Form.Item>
              <Form.Item hidden={true} label="villageName" name="villageName">
                <Input />
              </Form.Item>
              <Divider />
              <Title level={5}>Chi tiết đơn hàng:</Title>
              <ProductUtil />
              <br />
              <Divider />

              <Divider />
              <Title level={5}>Giảm giá:</Title>
              <Form.Item label="Mã giảm giá" name="vouchers">
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn mã giảm giá..."
                  onChange={onSelectVoucher}
                >
                  <Option value="" dataValue={0}>
                    ---Không chọn---
                  </Option>
                  {lstVoucher == null ||
                  lstVoucher === "undefined" ||
                  lstVoucher === []
                    ? []
                    : lstVoucher.map((item, key) => (
                        <Option
                          key={key}
                          value={item.id}
                          dataValue={item.value}
                        >
                          {item.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Title level={5}>Ghi chú:</Title>
              <Form.Item label="Ghi chú" name="note">
                <TextArea rows={3} />
              </Form.Item>
              <Divider />

              {isShippingGhtk ? (
                <>
                  {" "}
                  <Title level={5}>Kho hàng:</Title>
                  <Form.Item
                    label="Địa chỉ kho lấy hàng"
                    name="addressStore"
                    tooltip="Vui lòng chọn địa chỉ kho hàng để tính phí ship của GHTK"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn  địa chỉ kho hàng!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Chọn địa chỉ kho..."
                      onChange={onSelectStore}
                    >
                      {lstAddressStore == null ||
                      lstAddressStore === "undefined" ||
                      lstAddressStore === []
                        ? []
                        : lstAddressStore.map((item, key) => (
                            <Option key={key} value={item.id} dataValue={item}>
                              {`${item.name}---(${item.village.name}--${item.district.name}--${item.province.name})`}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                  <Divider />
                </>
              ) : null}

              <Title level={5}>Giá tri đơn hàng :</Title>

              <Row gutter={[24, 0]} align="center">
                <Col span={6} className="mb-24">
                  <Title level={5}>
                    <b>Tổng tiền sản phẩm : </b>
                    <span className="text-light-success ">
                      + {currencyFormat(totalMoneyProducts)}{" "}
                    </span>
                  </Title>
                  <Title level={5}>
                    <b>Phí vận chuyển : </b>
                    <span className="text-light-success ">
                      + {currencyFormat(totalShipping ? totalShipping : 0)}
                    </span>
                    <br /> <br />
                    <div>
                      <InputNumber
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                        addonAfter={<MdOutlineAttachMoney />}
                        onChange={(e) => {
                          setTotalShipping(e);
                        }}
                        value={totalShipping}
                        min={0}
                      />
                    </div>
                  </Title>
                  <Title level={5}>
                    <b>Mã giảm giá : </b>
                    <span className="text-light-danger">
                      - {currencyFormat(voucherValue)}{" "}
                    </span>
                  </Title>
                </Col>
                <Col span={6} className="mb-24">
                  <Card bordered={false} className="criclebox ">
                    <div className="number">
                      <Row align="middle" gutter={[24, 0]}>
                        <Col xs={18}>
                          <span>Tổng tiền</span>
                          <Title level={3}>{currencyFormat(totalMoney)}</Title>
                        </Col>
                        <Col xs={6}>
                          <div className="icon-box">{dollar}</div>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default OrderAdd;
